import React from 'react';
import { COLORS } from '../../../shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div', React.forwardRef)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    flex-direction: column;
    background-color: ${COLORS.newBg};
    overflow: auto;
`;

export const SizeContainer = styled('div')`
    position: relative;
    display: grid;
    flex-grow: 1;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    flex-grow: 1;
    grid-template-areas: 'nav content';
    grid-template-columns: 96px 1fr;
    align-items: stretch;
`;

export const ToastContainer = styled('div', React.forwardRef)`
    position: absolute;
    display: flex;
    width: 380px;
    top: 16px;
    flex-direction: column;
`;

export const CookiesContainer = styled('div')`
    position: fixed;
    display: flex;
    width: 440px;
    bottom: 16px;
    right: 16px;
    z-index: 15;
`;

export const Content = styled('main')`
    position: relative;
    display: flex;
    grid-area: content;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    z-index: 1;
`;
